import React, { useState, useEffect, useCallback } from 'react';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DayJsUtils from '@date-io/dayjs';
import ITit from 'dayjs/locale/it';
import { Controller } from 'react-hook-form';

type Props = {
  error?: string | null;
  label: string;
  defaultOptions?: string[];
  control: any;
  name: string;
  register: any;
  required?: boolean;
  fieldClassName?: string;
  cbFunction?: Function;
  minDate?: Date;
};

const DateField: React.FC<Props> = ({
  error,
  label,
  control,
  name,
  register,
  required,
  fieldClassName,
  cbFunction,
  minDate,
}) => {
  const [selectedDate, handleDateChange] = useState<any>();

  useEffect(
    useCallback(() => {
      if (cbFunction) {
        cbFunction(selectedDate);
      }
    }, [selectedDate, cbFunction]),
  );

  return (
    <MuiPickersUtilsProvider utils={DayJsUtils} locale={ITit}>
      <Controller
        name={name}
        control={control}
        onChange={([date]:any) => {
          handleDateChange(date.toString());
          return date.toString();
        }}
        className={fieldClassName}
        as={
          <DateTimePicker
            inputProps={{
              ref: register({ required }),
            }}
            inputVariant="outlined"
            size="small"
            fullWidth
            format="D MMMM YYYY @ HH:mm"
            value={selectedDate}
            onChange={e => handleDateChange(e?.toString())}
            error={!!error}
            helperText={error}
            label={label}
            minDate={minDate}
          />
        }
      />
    </MuiPickersUtilsProvider>
  );
};

DateField.displayName = 'DateField';

export default React.memo(DateField);
